import { createFileRoute } from '@tanstack/react-router';

import { InboxEmptyPage } from '@/features/conversations';

export const Route = createFileRoute('/_authed/_active/s/$storeId/inbox/')({
  component: InboxEmptyPage,
});
